import React, { useEffect, useState } from "react";
import  "./LinkInfo.css";
import Aux from "../../hoc/Auxiliary"

const Links =  (props) => {   
   const [numItems,setNumItems] = useState(4);
   const [currItems,setCurrItems] = useState([]);
    useEffect(()=>{
        if(props.items.length>0){
            let items=[];
            let baseUrl =window.location.origin;
           
            items=  props.items.map((item,index) => {

                let itemImg= !!item.MatalLogo ? baseUrl+ item.MatalLogo.ImageUrl: ''; 
                return (
                    // col-4 col-md-1
                        <div key={index} className="common-actions col-3 col-md-3 col-lg-2 col-xl-1">
                        <div className={'img-parent'}>
                        {!!itemImg   &&
                            <img src={itemImg} className={'common-action-img'} />
                        }
                        </div>
                       <div className={'common-actions-card'}>
                        <a href={item.MatalTextUrl} aria-label={item.MatalLogoText} role="link">
                            {item.MatalLogoText}
                        </a>
                        </div>
                    </div>
                );
            });
            setCurrItems(items);
            if(props.items.length>4){
                setNumItems(6);
            }
    }
   },[props.items]);
     let title = props.title;

    return (
        <div className={'links'}>
             <div className="LinksTitle ">{title} </div>
             <div className="links-warpper col-12 col-md-12">
                        {currItems}                    
            </div>
        </div>
    )

}
export default Links;
